/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
export default {
  name: 'sdl-tab',
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    tabData: {
      default: null,
    },
    /** *
     * Function to execute before tab switch. Return value must be boolean
     * If the return result is false, tab switch is restricted
     */
    beforeChange: {
      type: Function,
    },
    id: String,
    route: {
      type: [String, Object],
    },
    disabled: Boolean,
    transitionName: String,
    transitionMode: String,
  },
  computed: {
    isValidParent() {
      return this.$parent.$options.name === 'sdl-tabs';
    },
    hash() {
      return `#${this.id}`;
    },
    tabId() {
      return this.id ? this.id : this.title;
    },
  },
  data() {
    return {
      active: false,
      validationError: null,
    };
  },
  mounted() {
    this.$parent.addTab(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.$parent.removeTab(this);
  },
  render() {
    return (
      <section
        class="tab-container"
        id={`p-${this.tabId}`}
        aria-labelledby={`t-${this.tabId}`}
        role="tabpanel"
        v-show={this.active}
      >
        {this.$slots.default}
      </section>
    );
  },
};



// WEBPACK FOOTER //
// ./src/components/common/control/tabs/VTab.js